<template>
  <modal :name="modalName"
         :draggable="true"
         width="90%"
         height="auto"
         :scrollable="true"
  >
    <div class="m-4 p-4 border border-gray-500">
      <trial-form :actionUrl="'/trials/'+trial.id+'.json'" method="put" :initial-trial="trial" v-on:updated="updated"/>
    </div>
  </modal>
</template>

<script>
export default {
  props: ['trial'],
  data() {
    return {
      modalName: 'trial-form-modal-'+this.trial.id,
    }
  },
  methods: {
    updated: function (event) {
      this.$modal.hide(this.modalName);
      this.$emit('updated');
    },
  }
}
</script>